<template>
  <div class="card">
    <div class="card-header">
      <button class="btn btn-error float-right" @click="deletePurchase"><i class="icon icon-delete"></i></button>
      <button class="btn btn-primary float-right" @click="editPurchase"><i class="icon icon-edit"></i></button>
      <div class="card-title h5">Purchase {{index + 1}}</div>
      <!-- <div class="card-subtitle text-gray">Software and hardware</div> -->
    </div>
    <div class="card-body">
      <ul class="stats">
        <li class="text-left">
          <p>{{purchaseData.amount}} <small>{{purchaseData.code}}</small></p>
          <p><small>coin</small></p>
        </li>
        <li class="text-center">
          <p>{{calcWorth()}} <small>GBP</small></p>
          <p> <small>worth</small></p>
        </li>
        <li class="text-right">
          <p>{{helper.getCurrencyString(parseFloat(purchaseData.purchasePrice))}} <small>GBP</small></p>
          <p> <small>purchase price</small></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Router from '@/router';
import Helper from '@/utils/Helper';
import Service from '@/service';

export default {
  name: 'PurchaseCard',
  props: [
    'index',
    'purchaseData',
    'price',
  ],
  data() {
    return {
      helper: Helper,
    };
  },
  methods: {
    editPurchase() {
      Router.push({ name: 'Edit', params: { purchaseId: this.purchaseData.key } });
    },
    deletePurchase() {
      Service.removePurchase(this.purchaseData.key);
      this.$emit('deleted');
    },
    calcWorth() {
      if (this.price) return Helper.getCurrencyString(this.purchaseData.amount * this.price);

      return Helper.getCurrencyString(this.purchaseData.purchasePrice);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin: 0.5rem;

  .card-header {
    .btn.btn-primary {
      margin-right: 0.8rem;
    }
  }

  .card-body {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem;

    ul.stats {
      display: flex;
      width: 100%;
      margin: 0;

      & > li {
        display: flex;
        flex-direction: column;
        text-align: center;
        width: 33.33%;

        p {
          margin: 0;

          &:nth-child(2) {
            color: #9e9e9e;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/card/PurchaseCard.vue